
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/texas-search",
      function () {
        return require("private-next-pages/texas-search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/texas-search"])
      });
    }
  